/* unplugin-vue-components disabled */import { render } from "./OpenCloseItem.vue?vue&type=template&id=513d927e&scoped=true&ts=true"
import script from "./OpenCloseItem.vue?vue&type=script&lang=ts"
export * from "./OpenCloseItem.vue?vue&type=script&lang=ts"

import "./OpenCloseItem.vue?vue&type=style&index=0&id=513d927e&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513d927e"]])

export default __exports__